export default "__VITE_ASSET__3a8690da__"